import * as React from 'react';
import { t } from '../helper/locale';
import * as shield from '../assets/images/icon-shield.svg';
import Icon from './Icon';
import { HeaderBar } from './HeaderBar';
import { getDocument } from '../chrome/wrappers';
import { trackPageView } from '../actions/trackingActions';
import { OnboardingTrackingPages } from '../constants';

export const SetupComplete: React.FunctionComponent = () => {
  React.useEffect(() => {
    getDocument().title = t('This Chromebook is now protected!');
    trackPageView({ name: OnboardingTrackingPages.SETUP_SUCCESSFUL });
  }, []);
  return (
    <div>
      <HeaderBar />
      <div className="SetupComplete">
        <Icon className="SetupComplete__icon" path={shield} />
        <h1>{t('All done!')}</h1>
        <p className="SetupComplete__text">
          {t('This device is now protected by {{shortName}}.', {
            shortName: t('Qustodio'),
          })}
        </p>
      </div>
    </div>
  );
};
